export const fetchUrl = process.env.NODE_ENV === 'production' ? '/api/' : 'http://localhost:8003/api/'
export const mediaUrl = process.env.NODE_ENV === 'production' ? '/media/' : 'http://localhost:8003/media/'